const WhatWeDoData=[
    {
        id:1,
        img:"./assests/images/who-we-are.png",
        title:"Who We Are?",
        desc:`Paper Help Desk is considered as most reliable and
        professional organisation for editing and research services.
        Our organisation provided our editing services all across
        the world ranging from organisations to students and
        professionals and so on. The services of editing and
        research demand the experts for all subject matters, and our
        organisation believes in specialisation and perfection.
        Thus, our experts give their 100 percent to provide best
        possible services for the clients.`
    },
    {
        id:2,
        img:"./assests/images/what-we-do.png",
        title:"What We Do?",
        desc:` Our organisation transforms your paper by correcting its
        problems such as grammatical issues, referencing styles,
        formatting problems, and others. Furthermore, our experts
        enhance the worth of your research paper by rectifying its
        structure and sequence. Thousands of students acquired our
        services to improve their research papers and to getting rid
        of their academic worries.`
    },
    {
        id:3,
        img:"./assests/images/how-can we help.png",
        title:"How We Can Help?",
        desc:`Our team of Experts is the most updated team regarding the
        modern education system, thereby, we provide consultation
        services as well to support students in their academic
        journey. This organisation supports students from multiple
        aspects including editing, research and consultation. As a
        result, in order to clear out your academic worries and
        tensions you can contact with our organisation.`
    },

]

export default WhatWeDoData